/* const modal = {
  button: document.querySelectorAll('.js-modal-button'),
  content: document.querySelectorAll('.js-modal-content'),
  
  close: document.querySelectorAll('.js-modal-close'),
}; */
const closebg = document.querySelector<HTMLElement>(
  '.js-modal-bg-close'
) as HTMLElement;

document.addEventListener('click', (event) => {
  if (closebg.classList.contains('js-modal-bg-close--open--gray') || closebg.classList.contains('js-modal-bg-close--open')) {
    if ((event as any).target.closest('.js-modal-close')) {
      ModalClose();
      event.stopPropagation();
      event.stopImmediatePropagation()
    } else if (!(event as any).target.closest('.p-wrapper__modal--open')) {
      ModalClose();
    }
  }
  const tclosebg = (event as any).target.closest('.js-modal-bg-close');
  if (tclosebg) {
    ModalClose();
  }
});


document.addEventListener('click', (event) => {
  const button = (event as any).target.closest('.js-modal-button');
  if (button) {
    let modalContent: HTMLElement = button.querySelector(
      '.js-modal-content'
    ) as HTMLElement;
    if (!button.classList.contains('js-modal-button--open')) {
      button.classList.add('js-modal-button--open');
      ModalOpen(modalContent as HTMLElement);
    }
  }
});
window.addEventListener('load', () => {
  //ロード時にモーダル背景をオン
  const content = document.querySelector(".js-modal-button--open") as HTMLElement;
  if (content) {
    let modalBackType: string = 'js-modal-bg-close--open';
    if ((content as HTMLElement).dataset.modal === 'gray') {
      modalBackType = 'js-modal-bg-close--open--gray';
    }
    ModalBackToggle(modalBackType);
  }
});

const ModalClose = () => {
  document.querySelectorAll('.js-modal-content').forEach((content) => {
    content.classList.remove('p-wrapper__modal--open');
  });
  closebg.classList.remove('js-modal-bg-close--open');
  closebg.classList.remove('js-modal-bg-close--open--gray');
  document.querySelectorAll('.js-modal-button').forEach((button) => {
    button.classList.remove('js-modal-button--open');
  });
  const addForm = document.querySelectorAll(".p-form__add") as NodeListOf<HTMLElement>;
  setTimeout(()=>{
    addForm.forEach((form)=>{
      form.style.zIndex = "8";
    })
  },600);
};

export const ModalOpen = async (elm: HTMLElement): Promise<void> => {
  try {
    let modalBackType: string = 'js-modal-bg-close--open';
    if (elm.dataset.modal === 'gray') {
      modalBackType = 'js-modal-bg-close--open--gray';
    }
    await OpenStart(elm, modalBackType);
    await OpenCheck(elm, 200, modalBackType);
  } catch (e) {
    console.log(
      `[class="js-modal-button"]要素の配下に[class="js-modal-content"]要素が設置されていません`
    );
  }
};

const OpenStart = (
  elm: HTMLElement,
  modalBackType: string
): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!elm.classList.contains(modalBackType)) {
      ModalBackToggle(modalBackType);
    }
    const addForm = elm.closest(".p-form__add") as HTMLElement;
    if (addForm) {
      addForm.style.zIndex = "100";
    }
    elm.classList.toggle('p-wrapper__modal--open');
    resolve(true);
  });
};

const OpenCheck = (
  elm: HTMLElement,
  ms: number,
  modalBackType: string
): Promise<boolean> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let openElement: any = [];
      if (
        elm.classList.contains(
          'p-wrapper__modal--open' || 'p-wrapper__modal--open--gray'
        )
      ) {
        openElement.push(elm);
      }
      if (openElement.length < 1) {
        ModalBackToggle(modalBackType);
      }
      resolve(true);
    }, ms);
  });
};

const ModalBackToggle = (modalBackType: string) =>
  closebg.classList.toggle(`${modalBackType}`);
